/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import { webApi } from '../../../lib/WebApi.js'

import { loadRoster } from './players'


export const LOGIN = 'LOGIN'
export function login(team, pw) {
    let teamId = parseInt(team, 10)
    return function (dispatch) { 
        webApi.login(team, pw)
            .then(success => {
                console.log('login success', success, team, teamId)
                if (success && parseInt(team, 10) === parseInt(teamId, 10)) {
                    dispatch({ type: LOGIN, isLoggedIn: true, loginError: null })
                    dispatch(loadAll(team))
                } else {
                    dispatch({ type: LOGIN, isLoggedIn: false, loginError: 'Check password and try again' })
                }
            })
            .catch(err => {
                console.log('login failed')
                dispatch({ type: LOGIN, isLoggedIn: false, loginError: err })
            })
    }
}

export function setLoggedIn(loggedIn) {
    return {
        type: LOGIN,
        isLoggedIn: loggedIn,
        loginError: null
    }
}

export const SET_TEAM = 'SET_TEAM'
export function setTeam(team) {
    return {
        type: SET_TEAM,
        team: team
    }
}

export const SET_GAME = 'SET_GAME'
export function setGame(game) {
    let athletes = {}
    game.home_team.players.forEach(item => {athletes[item.trace_number] = item; item.user_id = item.user.user_id})
    return {
        type: SET_GAME,
        game: game,
        athletes: athletes
    }
}

export function loadGame(gameId) {
    return (dispatch) => {
        webApi.getGame(gameId)
            .then(game => {
                dispatch(setGame(game))
            })
            .catch(err => {
                console.log('action.loadGame error:', err)
            })
    }
}


export function loadAll(teamId, gameId = null) {
    console.log('rosters.actions.loadAll', teamId, gameId)
    return (dispatch, getState) => {
        webApi.getTeam()
            .then(team => {
                if (team.team_id === teamId) {
                    dispatch(setTeam(team))
                    dispatch(loadRoster(gameId))
                } else {
                    dispatch(setTeam({ title: '...'}))
                }
            })
            .catch(err => {
                console.log('action.loadAll error:', err)
                dispatch(setTeam({ title: '--'}))
            })
    }
}































export const LOAD_TRACERS_STARTED = 'LOAD_TRACERS_STARTED'
export function loadTracersStarted() {
    return {
        type: LOAD_TRACERS_STARTED,
    }
}

export const LOAD_TRACERS_SUCCESSED = 'LOAD_TRACERS_SUCCESSED'
export function loadTracersSuccessed(tracers) {
    return {
        type: LOAD_TRACERS_SUCCESSED,
        tracers
    }
}

export const LOAD_TRACERS_FAILED = 'LOAD_TRACERS_FAILED'
export function loadTracersFailed() {
    return {
        type: LOAD_TRACERS_FAILED,
    }
}

export function loadTracers() {
    return function(dispatch) {
        dispatch(loadTracersStarted())
        dispatch(loadTracersRequest((err, tracers) => {
            if (err) {
                dispatch(loadTracersFailed())
            } else {
                dispatch(loadTracersSuccessed(tracers))
            }
        }))
    }
}

export function loadTracersRequest(callback) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            const tracers = []

            tracers.push({
                name: 'Nettie Hawkins',
                number: '01',
                contacts: [
                    {
                        name: 'Mother',
                        email: 'mother@example.com'
                    },
                    {
                        name: 'Father',
                        email: 'father@example.com'
                    }
                ]
            })

            for (let i = 1; i < 20; i++) {
                tracers.push({
                    name: `Tracer ${i + 1}`,
                    number: (i + 1).toString().padStart(2, '0'),
                    isEmpty: true
                })
            }
            resolve(tracers)
        })
            .then((tracers) => {
                callback(null, tracers)
            })
    }
}

export const UPDATE_TRACER_STARTED = 'UPDATE_TRACER_STARTED'
export function updateTracerStarted() {
    return {
        type: UPDATE_TRACER_STARTED,
    }
}

export const UPDATE_TRACER_SUCCESSED = 'UPDATE_TRACER_SUCCESSED'
export function updateTracerSuccessed(tracer) {
    return {
        type: UPDATE_TRACER_SUCCESSED,
        tracer
    }
}

export const UPDATE_TRACER_FAILED = 'UPDATE_TRACER_FAILED'
export function updateTracerFailed() {
    return {
        type: UPDATE_TRACER_FAILED,
    }
}

export function updateTracer(tracer) {
    return function(dispatch) {
        dispatch(updateTracerStarted())
        dispatch(updateTracerRequest(tracer, (err, tracers) => {
            if (err) {
                dispatch(updateTracerFailed())
            } else {
                dispatch(updateTracerSuccessed(tracers))
            }
        }))
    }
}

export function updateTracerRequest(tracer, callback) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            resolve(tracer)
        })
            .then((tracer) => {
                callback(null, tracer)
            })
    }
}
